module.exports = __webpack_public_path__ + "static/media/7_l_ekran_24.58_91.02.3d001725.png";